import { useEffect, useEffectEvent, useRef } from 'react';
import { agentShortcutModifierKey } from '../keyboard';

export const useVoiceShortcut = ({
  onTap,
  onHoldStart,
  onHoldEnd,
}: {
  onTap: () => void;
  onHoldStart: () => void;
  onHoldEnd: (cancelled: boolean) => void;
}) => {
  const gesture = useRef<{ timer: number; held: boolean } | null>(null);
  const tapped = useEffectEvent(onTap);
  const held = useEffectEvent(onHoldStart);
  const released = useEffectEvent(onHoldEnd);
  const end = useEffectEvent((cancel: boolean) => {
    const current = gesture.current;
    if (!current) return;
    window.clearTimeout(current.timer);
    gesture.current = null;
    if (current.held) released(cancel);
    else if (!cancel) tapped();
  });
  useEffect(() => {
    const keyup = (event: KeyboardEvent) => {
      if (event.code === 'Space' || event.key === ' ' || event.key === agentShortcutModifierKey())
        end(false);
    };
    const blur = () => end(true);
    const visibility = () => {
      if (document.hidden) end(true);
    };
    window.addEventListener('keyup', keyup);
    window.addEventListener('blur', blur);
    document.addEventListener('visibilitychange', visibility);
    return () => {
      window.removeEventListener('keyup', keyup);
      window.removeEventListener('blur', blur);
      document.removeEventListener('visibilitychange', visibility);
      if (gesture.current) window.clearTimeout(gesture.current.timer);
    };
  }, []);
  return () => {
    if (gesture.current) return;
    const current = { timer: 0, held: false };
    current.timer = window.setTimeout(() => {
      current.held = true;
      held();
    }, 300);
    gesture.current = current;
  };
};
